import { createFileRoute } from '@tanstack/react-router'

import { LeaveTypesPage } from '@/features/leave/pages/LeaveTypesPage'

export const Route = createFileRoute('/_authenticated/leave/config/leave-types')({
  component: LeaveTypesPage,
})
